<template>
  <div
    class="lottery-place-container"
    :style="{ backgroundColor: data.backgroundColor }"
  >
    <div class="swiper-wrapper">
      <Swipe :autoplay="3000" :show-indicators="false">
        <SwipeItem v-for="item in data.bannerUrl" :key="item">
          <div
            class="img-wrapper"
            :style="{ backgroundImage: 'url(' + item + ')' }"
          ></div>
        </SwipeItem>
      </Swipe>
    </div>
    <div class="scroll-wrapper">
      <Tabs v-model="active" scrollspy sticky :offset-top="tabs_height" :swipe-threshold="3" >
        <Tab
          v-for="item in list"
          :title="item.themeName"
          :key="item.actThemeId"
        >
          <component :is="panel_c(item.themeType)" :data="item" />
        </Tab>
      </Tabs>
    </div>
  </div>
</template>

<script>
import PanelBrand from "@/components/activity/panel/brand";
import PanelGoods from "@/components/activity/panel/goods";
import PanelSuit from "@/components/activity/panel/suit";
import { Tabs, Tab, Swipe, SwipeItem } from "vant";
import {
  getDoubleCommissionDetail,
  getDoubleCommissionList,
} from "@/api/doubleCommission";
export default {
  components: {
    Tabs,
    Tab,
    PanelBrand,
    PanelGoods,
    PanelSuit,
    Swipe,
    SwipeItem,
  },
  data() {
    return {
      tabs_height: 0,
      active: 0,
      data: {
        bannerUrl: [],
        backgroundColor: "#f7372e",
      },
      list: [],
    };
  },
  computed: {
    panel_c() {
      return (type) => {
        switch (type) {
          case "brand":
            return "PanelBrand";
          case "goods":
            return "PanelGoods";
          case "suit":
            return "PanelSuit";
        }
      };
    },
  },
  created() {
    this.getData();
  },
  mounted() {
    const headerDOM = document.querySelector('#home .homepageheader .van-sticky')
    this.tabs_height = headerDOM.querySelector('.top-bar').offsetHeight + headerDOM.querySelector('.bottom-bar').offsetHeight
  },
  methods: {
    getData() {
      this.$store.dispatch("app/showLoading");
      Promise.all([getDoubleCommissionDetail(), getDoubleCommissionList()])
        .then(([res1, res2]) => {
          // res1
          this.$store.dispatch("app/hideLoading");
          this.data.bannerUrl = res1.data.bannerUrl;
          this.data.backgroundColor = res1.data.colorCode;
          // res2
          this.list = this.converData(res2.data);
        })
        .catch(() => {
          this.$store.dispatch("app/hideLoading");
        });
    },
    converData(data) {
      data.forEach((item) => {
        if (item.themeType === "suit") {
          item.themeSuitH5List.forEach((_item) => {
            _item.activityReward = "COMMISSION";
          });
        }
        if (item.themeType === "goods") {
          item.themeGoodsList.forEach((_item) => {
            _item.activityReward = "COMMISSION";
          });
        }
        if (item.themeType === "brand") {
          item.themeBrandList.forEach((_item) => {
            _item.activityReward = "COMMISSION";
          });
        }
      });
      return data;
    },
  },
};
</script>

<style lang="less" scoped>
.lottery-place-container {
  min-height: 100vh;
  padding-bottom: 200px;
  .swiper-wrapper {
    width: 100%;
    height: 240px;
    .van-swipe {
      height: 100%;
    }
    .img-wrapper {
      width: 100%;
      height: 100%;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center center;
    }
  }
  .scroll-wrapper {
    .van-tabs {
      & /deep/ .van-sticky {
        .van-tabs__wrap {
          box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.14);
          height: 76px;
          .van-tab {
            padding: 0 12px;
            color: #e82035;
            transition: 0.1s;
            &.van-tab--active {
              color: #fff;
              background-color: #e82035;
            }
          }
          .van-tabs__line {
            display: none;
          }
        }
      }
    }
  }
  .panel {
    padding-bottom: 16px;
  }
}
</style>